import { useEffect } from 'react'
import { useRecoilValue, useResetRecoilState } from 'recoil'

import CardWithBorder from '../../../components/CardWithBorder'
import TableWithPagination from '../../../components/TableWIthPagination'
import { PAGE_SIZE } from '../../../config/consts'
import useLocationDateTimeForm from '../../../hooks/useLocationDateTimeForm'
import { ServiceAtom, TableAtom } from '../../../recoil/atoms'
import { calcOffset, parseNumber } from '../../../utils/display'
import useGetStoreVisitCountStoreRank from '../hooks/useGetStoreVisitCountStoreRank'

function UserVisitSiteRanking({ className }: { className?: string }) {
  const { form } = useLocationDateTimeForm()
  const service = useRecoilValue(ServiceAtom)
  const tableOpt = useRecoilValue(TableAtom('rankingsForSite'))
  const resetTableOpt = useResetRecoilState(TableAtom('rankingsForSite'))

  const { stampCampaignRankStoreRank, stampCampaignRankStoreRankLoading } = useGetStoreVisitCountStoreRank({
    serviceId: service.value,
    fromDate: form.fromDate,
    toDate: form.toDate,
    offset: calcOffset(tableOpt.current, PAGE_SIZE),
    sortTarget: tableOpt.sortTarget ?? 2,
    isAsc: tableOpt.isAsc,
  })

  useEffect(() => {
    resetTableOpt()
  }, [form, resetTableOpt])

  return (
    <CardWithBorder
      className={`${className} relative`}
      title='サイト別ランキング'
      visible={stampCampaignRankStoreRankLoading}
    >
      <TableWithPagination
        labels={['サイトID', 'サイト名', 'ユニーク来訪者', '来訪回数', 'アプリ連続利用平均時間']}
        unSortableIndex={[0, 1]}
        name='rankingsForSite'
        elements={
          stampCampaignRankStoreRank?.storeVisitCountStoreRankDatas?.map((e) => [
            e.siteId?.toString() ?? e.siteId,
            e.siteName,
            `${parseNumber(e.storeVisitCountUUDataRange)} 人`,
            `${parseNumber(e.storeVisitCount)} 回`,
            `${parseNumber(Math.round(e.avgDwellTime / 60))} 分`,
          ]) ?? []
        }
        pageSize={PAGE_SIZE}
        total={stampCampaignRankStoreRank?.totalCount ?? 0}
      />
    </CardWithBorder>
  )
}

UserVisitSiteRanking.defaultProps = {
  className: '',
}

export default UserVisitSiteRanking
